import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'

import { useDisciplineStore } from '@stores/discipline'
import { useProgressReportStore } from '@stores/progress-report'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

interface ProgressReportsListApiOptions {
  onStart?: () => void
  onSuccess?: (reports: ProgressReport[]) => void
  onError?: (err: any) => void
  onFinish?: () => void
}

interface ProgressReportsListApiReturn {
  getProgressReportList: () => Promise<void>
}

export const useProgressReportsListApi = (options?: ProgressReportsListApiOptions): ProgressReportsListApiReturn => {
  const getProgressReportList = async (): Promise<void> => {
    const { $axios } = useNuxtApp()

    const disciplineStore = useDisciplineStore()
    const progressReportStore = useProgressReportStore()

    const discipline = disciplineStore.activeDiscipline!

    if(!discipline) {
      console.error('No active discipline found')
      return
    }

    const url = useCsRoutes('disciplines.progress-reports', {
      '[discipline_id]': discipline.id,
    })

    if(!url) {
      console.error('No progress reports route found')
      return
    }

    options?.onStart?.()
    progressReportStore.setReports([])
    progressReportStore.setReportsLoading(true)

    try {
      const { data } = await $axios.get(url)
      const reports: ProgressReport[] = data.data || []

      progressReportStore.setReports(reports)
      options?.onSuccess?.(reports)
    } catch (err: any) {
      console.error(err)
      options?.onError?.(err)
    } finally {
      options?.onFinish?.()
      progressReportStore.setReportsLoading(false)
    }
  }

  return {
    getProgressReportList,
  }
}
